import { AppFile } from "../models/app-file";

export class CompanyFile {
  id: number;
  companyId: number;
  appFileId: number;
  appFile: AppFile = new AppFile();
}



// WEBPACK FOOTER //
// ./src/app/core/models/company-file.ts